import { send_to_server } from '@/services/socketio_client_react/send_to_server';
import { ActionReducerMapBuilder, PayloadAction } from '@reduxjs/toolkit';
import { createAsyncThunkSafe } from '../../_base/createAsyncThunkSafe';

import { RequestCollectionUpdateName } from '@shared/dto/collection/_requests/request_collection_update_name';
import { ENUM__network_event_client_to_server } from '@shared/network/ENUM__network_event_client_to_server';
import { STATE__collections } from '../STATE__collections';

export const remote_collection_update_name = createAsyncThunkSafe<void, RequestCollectionUpdateName>(
  ENUM__network_event_client_to_server.COLLECTION_UPDATE_NAME,
  async (request, thunkApi): Promise<void> => {
    await send_to_server(ENUM__network_event_client_to_server.COLLECTION_UPDATE_NAME, request);
  },
);

export function init_remote_collection_update_name(builder: ActionReducerMapBuilder<STATE__collections>) {
  builder
    .addCase(remote_collection_update_name.pending, (state, action) => {
      let request = action.meta.arg;

      let grid2d_collection = state.collections_map.get_or_assert(request.collection_id, { context: 'grid2d_collection' });

      state.collections_map.set(request.collection_id, grid2d_collection.clone({ name: request.name }));
    })
    .addCase(remote_collection_update_name.rejected, (state, action) => {})
    .addCase(remote_collection_update_name.fulfilled, (state, action: PayloadAction) => {});
}
